<template>
  <div class="home">
    <AccessPermissionFileExplorer :indexesHistoryProps="indexesHistoryProps" :content="content" :loadingContent="loadingContent" :loadingError="loadingError"
     :notInicialized="notInicialized" :notInicializedSalesforce="notInicializedSalesforce"
     :allowCreate="allowCreate" :allowDelete="allowDelete" :allowRename="allowRename" :allowUpload="allowUpload"/>
  </div>
</template>

<script>
import AccessPermissionFileExplorer from '@/components/access-permission-explorer/index.vue';
import { getDirectoryAccessPermission, getJWTToken } from '@/common/driveserver';
import store from '../../common/store';

export default {
  name: 'Home',
  components: { AccessPermissionFileExplorer },
  data: () => ({
    content: {},
    loadingContent: true,
    loadingError: false,
    notInicialized: false,
    notInicializedSalesforce: false,
    allowCreate: false,
    allowDelete: false,
    allowRename: false,
    allowUpload: false,
  }),
  props: {
    path: {
      type: String,
      required: false,
      default: '',
    },
    indexesHistoryProps: {
      type: Array,
      required: false,
    },
  },
  async created() {
    await getJWTToken()
      .then((response) => {
        if (response && response.data) {
          store.saveToken(response.data.token);
        }
      }).finally(() => {
        this.loaded = true;
      });

    getDirectoryAccessPermission(this.path, store.getToken())
      .then((response) => {
        this.$set(this, 'content', response.data);
        this.loadingContent = false;
        this.allowCreate = response.data.allowCreate;
        this.allowDelete = response.data.allowDelete;
        this.allowRename = response.data.allowRename;
        this.allowUpload = response.data.allowUpload;
      })
      .catch((error) => {
        if (error && error.response && error.response.status === 404) {
          this.loadingContent = false;
          if (error.response.data === 'company') {
            this.notInicialized = true;
          } else if (error.response.data === 'salesforce') {
            this.notInicializedSalesforce = true;
          }
        } else {
          this.loadingError = true;
        }
      })
      .finally(() => {
        this.loadingContent = false;
      });
  },
};
</script>
